import React from "react";
import { SvgIcon } from "@mui/material";
import socialLinkIconStyles from "../../icons/socialLinkIconStyles";

const InstagramLogoIcon = ({ color }: any) => {  
  return (
    <SvgIcon sx={socialLinkIconStyles(color)}>
      <svg stroke="currentColor" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6201_33224)">
          <path
            d="M12 15.375C13.864 15.375 15.375 13.864 15.375 12C15.375 10.136 13.864 8.625 12 8.625C10.136 8.625 8.625 10.136 8.625 12C8.625 13.864 10.136 15.375 12 15.375Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.5 3H7.5C5.01472 3 3 5.01472 3 7.5V16.5C3 18.9853 5.01472 21 7.5 21H16.5C18.9853 21 21 18.9853 21 16.5V7.5C21 5.01472 18.9853 3 16.5 3Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.875 8.625C17.7034 8.625 18.375 7.95343 18.375 7.125C18.375 6.29657 17.7034 5.625 16.875 5.625C16.0466 5.625 15.375 6.29657 15.375 7.125C15.375 7.95343 16.0466 8.625 16.875 8.625Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_6201_33224">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default InstagramLogoIcon;